import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

// breaks: true matches showdown's previous behavior of turning single
// newlines into <br>, so existing community texts keep their layout.
marked.setOptions({ gfm: true, breaks: true });

const getHtmlFromMarkdown = markdownText => {
  if (!markdownText) return { __html: '' };
  const rawHtml = marked.parse(markdownText);
  const cleanHtml = DOMPurify.sanitize(rawHtml);
  return { __html: cleanHtml };
};

const Markdown = ({ markdown }) => {
  const content = useMemo(() => getHtmlFromMarkdown(markdown), [markdown]);

  return (
    // eslint-disable-next-line react/no-danger
    <div className="markdown-content" dangerouslySetInnerHTML={content} />
  );
};

Markdown.propTypes = { markdown: PropTypes.string };
Markdown.defaultProps = { markdown: undefined };

export default Markdown;
